<div class="p-6 bg-white rounded-xl shadow-lg">
  <h2 class="text-2xl font-bold text-gray-800 mb-6">Vendor Management</h2>

  <div *ngIf="loading" class="text-gray-500">Loading vendors...</div>

  <table *ngIf="!loading && vendors.length > 0" class="w-full border-collapse">
    <thead>
      <tr class="bg-blue-100 text-left">
        <th class="p-3 border">Vendor ID</th>
        <th class="p-3 border">Name</th>
        <th class="p-3 border">Email</th>
        <th class="p-3 border">Approved</th>
        <th class="p-3 border">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let vendor of vendors" class="hover:bg-gray-50">
        <td class="p-3 border">{{ vendor.vendorId }}</td>
        <td class="p-3 border">{{ vendor.storeName }}</td>
        <td class="p-3 border">{{ vendor.contactEmail }}</td>
        <td class="p-3 border">
          <span [ngClass]="{
              'bg-green-100 text-green-800 px-2 py-1 rounded': vendor.isApproved,
              'bg-yellow-100 text-yellow-800 px-2 py-1 rounded': !vendor.isApproved
            }">
            {{ vendor.isApproved ? 'Approved' : 'Pending' }}
          </span>
        </td>
        <td class="p-3 border space-x-2">
          <button *ngIf="!vendor.isApproved"
                  (click)="approveVendor(vendor.vendorId)"
                  class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded">
            Approve
          </button>
          <button *ngIf="!vendor.isApproved"
                  (click)="rejectVendor(vendor.vendorId)"
                  class="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded">
            Reject
          </button>
          <button (click)="deleteVendor(vendor.vendorId)"
                  class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!loading && vendors.length === 0" class="text-gray-500">
    No vendors found.
  </div>
</div>

